"use client";

import React from "react";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal, Stagger, StaggerItem } from "@/components/shared/motion";

/**
 * AquaGlobe FAQ — frosted-glass <details> accordion with 5 claim-safe Q&As.
 * Glass-native; no eSIMSUPRA section reuse.
 */
export default function FaqSection() {
  const { t } = useTranslations();

  const faqs = [
    {
      q: t("aqua.faq.q1", "When should I install my eSIM?"),
      a: t("aqua.faq.a1", "Install anytime before your trip while on Wi-Fi, then switch on data when you arrive at your destination."),
    },
    {
      q: t("aqua.faq.q2", "How quickly will I receive my QR code?"),
      a: t("aqua.faq.a2", "Your eSIM QR code is delivered by email instantly after a secure checkout."),
    },
    {
      q: t("aqua.faq.q3", "Can I keep my regular phone number?"),
      a: t("aqua.faq.a3", "Yes. The eSIM is data-only, so your home SIM and number stay active for calls, texts, and messaging apps."),
    },
    {
      q: t("aqua.faq.q4", "What network will I connect to?"),
      a: t("aqua.faq.a4", "Plans run on reliable local 4G/5G networks, so you get fast data wherever coverage is available."),
    },
    {
      q: t("aqua.faq.q5", "Does the eSIM replace my physical SIM?"),
      a: t("aqua.faq.a5", "No. The eSIM works alongside your physical SIM, so you keep both your home line and your travel data."),
    },
  ];

  return (
    <section className="container mx-auto px-4 py-12">
      <div className="max-w-3xl mx-auto">
        <Reveal as="h2" className="text-2xl sm:text-3xl font-bold text-foreground text-center mb-8" y={14}>
          {t("aqua.faq.title", "Frequently asked questions")}
        </Reveal>

        <Stagger className="space-y-3" staggerChildren={0.06} amount={0.15}>
          {faqs.map(({ q, a }) => (
            <StaggerItem as="div" y={10} key={q}>
              <details className="aqua-glass group rounded-3xl p-5 backdrop-blur">
                <summary className="flex items-center justify-between cursor-pointer font-semibold text-foreground list-none">
                  {q}
                  <span className="text-primary transition-transform group-open:rotate-45 text-2xl leading-none">+</span>
                </summary>
                <p className="mt-3 text-sm text-muted-foreground">{a}</p>
              </details>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
